
import {
  ref,
  useFetch,
  useRoute,
  computed,
  watch,
  useMeta,
  defineComponent,
  useContext,
} from '@nuxtjs/composition-api';

import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue';
import { HeaderSectionImage } from '@webplatform/asbis-ui';
import CatalogProductCard from '@/domains/catalog/components/CatalogProductCard.vue';
import CatalogLayout from '@/domains/catalog/components/CatalogLayout.vue';
import CatalogFilter from '@/domains/catalog/components/CatalogFilter.vue';
import getCategoryAggs from '@/domains/categories/helpers/getCategoryAggs';
import { useFilter, useProductContent } from '~/composables';

export default defineComponent({
  components: {
    AppBreadcrumbs,
    HeaderSectionImage,
    CatalogProductCard,
    CatalogLayout,
    CatalogFilter,
  },
  setup() {
    const {
      error,
      ssrContext,
      i18n,
      $api: { categoriesService },
    } = useContext();
    const { selectedFilters, handleFilterChanged, getFiltersFromURL } =
      useFilter();
    const route = useRoute();
    const currentPage = computed(() => route.value.query.page);
    const category = ref();
    const categoryAggs = ref();
    const products = ref();
    const productsCount = ref();
    const categoryHeader = ref();
    const limit = ref(30);

    // TODO: переработать компонент CatalogProductCard, чтобы она принимала продукт и вызывала внутри useProductContent
    const getProductContent = (product) => {
      const { image, description } = useProductContent(product);
      return { image: image.value, description: description.value };
    };

    const pagesCount = computed(() => {
      return Math.ceil(productsCount.value / limit.value);
    });

    const fetchCategory = async (filtersData = {}) => {
      try {
        const { data } = await categoriesService.getCategoryBySlug(
          route.value.params.slug,
          {
            ...filtersData,
            page: currentPage.value,
            limit: limit.value,
            lang: i18n.locale,
          },
        );
        category.value = data;
        categoryAggs.value = getCategoryAggs(category.value);
        products.value = data.products;
        productsCount.value = data.products_meta_count;
        categoryHeader.value = category.value.contents?.find(
          (block) => block.type === 'catalog-header',
        )?.data;
      } catch (e) {
        if (ssrContext) ssrContext.res.statusCode = 404;
        else error({ statusCode: 404 });
      }
    };

    useFetch(async () => {
      await fetchCategory(selectedFilters.value);
    });

    watch(
      () => route.value.query,
      async () => {
        getFiltersFromURL();

        await fetchCategory(selectedFilters.value);
      },
    );

    const breadcrumbs = computed(() => [
      {
        text: category.value?.name,
      },
    ]);

    useMeta(() => ({
      title: category.value?.seo.page_title,
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: category.value?.seo.description,
        },
        {
          property: 'og:title',
          content: category.value?.seo.og_title,
        },
        {
          property: 'og:description',
          content: category.value?.seo.description,
        },
      ],
    }));

    return {
      breadcrumbs,
      categoryHeader,
      products,
      category,
      categoryAggs,
      pagesCount,
      selectedFilters,
      handleFilterChanged,
      getProductContent,
    };
  },
  head: {},
});
